// extracted by mini-css-extract-plugin
export var activityContainer = "_l5-0";
export var typingIndicatorContainer = "_l5-1";
export var typingIndicatorDot = "_l5-2";
export var wave = "_l5-3";